export const EMAIL = "j.maquestiau.therapie@gmail.com";
export const INSTAGRAM_URL = "https://www.instagram.com/j.maquestiau.therapie";
export const INSTAGRAM_HANDLE = "@j.maquestiau.therapie";
export const PHONE_DISPLAY = "0471/65.87.35";
export const PHONE_TEL = "+32471658735";

const SMS_MESSAGE = `(Merci de compléter le message)

Je souhaiterais prendre rendez-vous.

Nom du patient :
Prénom du patient :
Âge du patient :
Compléments d'informations utiles :`;

export const SMS_URL = `sms:${PHONE_TEL}?&body=${encodeURIComponent(SMS_MESSAGE)}`;
